import './App.css';
import { FormContextProvider } from './context/FormContext'
import JobApplicationForm from './components/JobApplicationForm'
import { createTheme, ThemeProvider } from '@mui/material'
import Blur from './components/Blur';
import { RootDivProvider } from './context/RootDivContext';

const theme = createTheme({

  typography: {
    fontFamily: 'Source Sans Pro, sans-serif',
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          marginBottom: '4px',
          height: '70px',
          '@media (min-width: 1024px)': {
            height: '80px',
          },
          '& input': {
            fontSize: '16px',
            '@media (min-width: 1024px)': {
              fontSize: '18px',
            }, // Force fontSize to 16px for input elements
          },
          '& textarea': {
            fontSize: '16px',
            '@media (min-width: 1024px)': {
              fontSize: '18px',
            }, // Force fontSize to 16px for textarea elements
          },
        },
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: '16px',
          '@media (min-width: 1024px)': {
            fontSize: '18px',
          }, // Force fontSize to 16px for label elements
        },
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: '16px',
          '@media (min-width: 1024px)': {
            fontSize: '18px',
          }, // Direct input elements
        },
        root: {
          '& .MuiInputLabel-root': {
            fontSize: '16px',
            '@media (min-width: 1024px)': {
              fontSize: '18px',
            }, // Labels within components like Autocomplete
          },
          '& .MuiFormHelperText-root': {
            fontSize: '16px',
            '@media (min-width: 1024px)': {
              fontSize: '18px',
            }, // Helper text within components
          },
        },
      },
    },
    MuiPopper: {
      styleOverrides: {
        root: {
          fontSize: '16px',
          '@media (min-width: 1024px)': {
            fontSize: '18px',
          }, // Popper content
        },
      },
    },
    // Overrides for Select components
    MuiSelect: {
      styleOverrides: {
        select: {
          fontSize: '16px',
          '@media (min-width: 1024px)': {
            fontSize: '18px', // Font size for screens wider than 1023px
          }, // For the selected value
        },
        icon: {
          // If you need to adjust the icon size, do it here
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: '12px',
          '@media (min-width: 1024px)': {
            fontSize: '14px', 
          }, // Helper text
        },
      },
    },
    // Overrides for FormControlLabel which might be used with Radio Buttons, Switches, etc.
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontSize: '16px',
          '@media (min-width: 1024px)': {
            fontSize: '18px', // Font size for screens wider than 1023px
          }, // For the label text
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        inputRoot: {
          '& .MuiInputLabel-root': {
            fontSize: '16px',
            '@media (min-width: 1024px)': {
              fontSize: '18px',
            },
             // Label for Autocomplete
          },
          '& .MuiInputBase-input': {
            fontSize: '16px',
            '@media (min-width: 1024px)': {
              fontSize: '18px',
            },
             // Input for Autocomplete
          },
          '& .MuiAutocomplete-option': {
            fontSize: '16px',
            '@media (min-width: 1024px)': {
              fontSize: '18px',
            },
             // Options for Autocomplete
          },
        },
        listbox: {
          fontSize: '16px',
          '@media (min-width: 1024px)': {
            fontSize: '18px',
          }, // Listbox for Autocomplete
        },
      },
    },
    // Overrides for Checkbox, Radio, and Switch labels if not wrapped in FormControlLabel
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '& .MuiSvgIcon-root': {
            fontSize: '20px',
            '@media (min-width: 1024px)': {
              fontSize: '30px',
            }, // Adjust label font size
          },
        },
      },
    },
  },
  palette: {
    primary: {
      main: '#1c2445',
    },
    error: {
      main: '#E35C40',
    }
  }
})


function App() {

  return (
    <RootDivProvider>
      <ThemeProvider theme={theme}>
        <FormContextProvider>
            <JobApplicationForm />
        </FormContextProvider>
        <Blur />
      </ThemeProvider>
    </RootDivProvider>
  );
}

export default App
